import type { FC } from 'react';

export const MessageIcon: FC<{
  color?: string;
}> = (props) => (
  <svg width="100%" height="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.0026 8C14.0026 11.3137 11.3163 14 8.0026 14C6.645 14 2.00309 14 2.00309 14C2.00309 14 3.04255 11.5041 2.62655 10.6672C2.22717 9.86373 2.00261 8.95813 2.00261 8C2.00261 4.68629 4.68889 2 8.0026 2C11.3163 2 14.0026 4.68629 14.0026 8Z"
      stroke={props.color || '#E6E6E9'}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
